var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isActive
    ? _c("div", { ref: "routingContainer", staticClass: "routing-container" }, [
        _c(
          "div",
          { staticClass: "routing-container-inner" },
          [
            _c("SimpleBar", [
              _c("div", { staticClass: "routing-header" }, [
                _c("a", { attrs: { href: "#" }, on: { click: _vm.onClose } }, [
                  _c("img", {
                    attrs: { src: "images/arrow_back.svg", alt: "" }
                  }),
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.i18n.detailsView.mobileBackButton) +
                      "\n\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "routing-search" }, [
                _c(
                  "form",
                  {
                    staticClass: "routing-form grid-layout",
                    attrs: { id: "routing-form", name: "routing-form" },
                    on: { submit: _vm.onSubmit }
                  },
                  [
                    _c("div", { staticClass: "input-wrapper start-point" }, [
                      _c("label", { attrs: { for: "start-point" } }, [
                        _vm._v("Von")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-content" }, [
                        _c("div", { staticClass: "input-content-inner" }, [
                          _c("input", {
                            ref: "startPoint",
                            staticClass: "start-point-input",
                            attrs: {
                              type: "text",
                              name: "start-point",
                              id: "start-point",
                              required: ""
                            },
                            domProps: { value: _vm.sourceValue }
                          }),
                          _vm._v(" "),
                          _vm.isSearchInputFilled
                            ? _c(
                                "button",
                                {
                                  staticClass: "ym-btn empty-search-button",
                                  attrs: { type: "button" },
                                  on: { click: _vm.emptySearchInput }
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("close")
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "ym-btn search-button",
                            attrs: { type: "submit" }
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("search")
                            ])
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "input-wrapper ending-destination" },
                      [
                        _c("label", { attrs: { for: "end-destination" } }, [
                          _vm._v("Nach")
                        ]),
                        _vm._v(" "),
                        _c("address", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.geocodedTarget.address.name) +
                              "\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.geocodedTarget.address.streetNo) +
                              "\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.geocodedTarget.address.zip) +
                              " " +
                              _vm._s(_vm.geocodedTarget.address.city) +
                              "\n\t\t\t\t\t\t"
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "routing-options flex-layout" },
                  _vm._l(_vm.speedProfiles, function(profile) {
                    return _c(
                      "button",
                      {
                        key: "speed-profile-" + profile,
                        class: _vm.activateSpeedProfileBtn(profile),
                        on: {
                          click: function($event) {
                            return _vm.onChangeSpeedProfile($event, profile)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(_vm._s(_vm.getSpeedProfileSrc(profile)))
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _vm.isEntrySet
                ? _c("div", { staticClass: "routing-information" }, [
                    _c("h3", [
                      _vm.durationHours > 0
                        ? _c("span", {
                            staticClass: "duration-hours",
                            domProps: {
                              innerHTML: _vm._s(_vm.durationHours + " h")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.durationMinutes > 0
                        ? _c("span", {
                            staticClass: "duration-minutes",
                            domProps: {
                              innerHTML: _vm._s(_vm.durationMinutes + " min")
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.$formatNumber(_vm.distance)) +
                          " " +
                          _vm._s(_vm.distanceUnit()) +
                          ")"
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isEntrySet
                ? _c("div", { staticClass: "routing-description" }, [
                    _c("div", { staticClass: "routing-description-header" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.i18n.routingView.yourLocation))
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.sourceValue))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "routing-description-list" }, [
                      _c(
                        "ul",
                        _vm._l(_vm.entry.waypoints, function(waypoint, index) {
                          return _c("li", { key: "waypoint-" + index }, [
                            _c(
                              "span",
                              {
                                class: {
                                  [`dir-${waypoint.navigationCommand.toString()}`]: true
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getWaypointSrc(waypoint),
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(waypoint.description))])
                          ])
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "rounting-description-target" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.geocodedTarget.address.name))
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.formatAddressLine(_vm.geocodedTarget))
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }